import { PlantInfo } from '../../interface/response/PlantResponse'

export const plantInitialValues = {
  plantName: '',
  address: '',
  city: '',
  zipCode: '',
  latitude: 0,
  longitude: 0,
  radius: 0,
  numberOfSilos: 0,
  //truckLoadingCount: 0,
  vendorName: '',
  vendorCode: '',
  status: '',
}
export const setInitialState = (info?: PlantInfo) => {
  return {
    plantCode: info?.plantCode,
    plantName: info?.plantName,
    address: info?.address,
    city: info?.city,
    state: info?.state,
    country: info?.country,
    zip: info?.zip,
    latitude: info?.latitude,
    longitude: info?.longitude,
    radius: info?.radius,
    numberOfSilos: info?.numberOfSilos,
    //truckLoadingCount: info?.truckLoadingCount,
    vendorName: info?.vendorName,
    vendorCode: info?.vendorCode,
    status: info?.status,
  }
}

export const plantBasicDetails = Object.freeze([
  {
    key: 'plantName',
    label: 'plant.plant_name',
  },
  {
    key: 'latitude',
    label: 'plant.latitude',
  },
  {
    key: 'vendorName',
    label: 'plant.vendorName',
  },
  {
    key: 'longitude',
    label: 'plant.longitude',
  },
  {
    key: 'radius',
    label: 'plant.radius',
  },
  {
    key: 'numberOfSilos',
    label: 'plant.no_of_silos',
  },
])
export const plantOperationDetails = Object.freeze([
  {
    key: 'plantWaitingTime',
    label: 'plant.plant_waiting_time',
  },
  {
    key: 'numberOfSilos',
    label: 'plant.no_of_silos',
  },
  {
    key: 'plantLoadingTime',
    label: 'plant.plant_loading_time',
  },

  // {
  //   key: 'truckLoadingCount',
  //   label: 'plant.truck_loading_count',
  // },
])
export const plantAddress = Object.freeze([
  {
    key: 'address',
    label: 'common.address',
  },
  {
    key: 'city',
    label: 'common.city',
  },
  {
    key: 'state',
    label: 'common.state',
  },
  {
    key: 'country',
    label: 'common.country',
  },

  {
    key: 'zip',
    label: 'common.zip_code',
  },
])
export const convertRequestFormatForEdit = (values: any) => {
  return {
    plantCode: values?.plantCode,
    plantDetails: {
      vendorCode: values?.vendorCode,
      plantName: values?.plantName,
      latitude: values?.latitude,
      longitude: values?.longitude,
      radius: values?.radius,
      address: values?.address,
      zip: values?.zip,
      city: values?.city,
      state: values?.state,
      country: values?.country,
      //truckLoadingCount: values?.truckLoadingCount,
      numberOfSilos: values?.numberOfSilos,
    },
  }
}
export const convertRequestFormatForCreate = (values: any) => {
  return {
    vendorCode: values?.vendorCode,
    plantName: values?.plantName,
    latitude: values?.latitude,
    longitude: values?.longitude,
    radius: values?.radius,
    address: values?.address,
    zip: values?.zip,
    city: values?.city,
    state: values?.state,
    country: values?.country,
    //truckLoadingCount: values?.truckLoadingCount,
    numberOfSilos: values?.numberOfSilos,
  }
}
export const PLANT_TIME_DEFAULT_VALUES = Object.freeze({
  PLANT_WAITING_TIME_MIN: 0,
  PLANT_WAITING_TIME_MAX: 300,
  PLANT_LOADING_TIME_MIN: 0,
  PLANT_LOADING_TIME_MAX: 300,
  TIME_TO_REACH_PLANT_MIN: 0,
  TIME_TO_REACH_PLANT_MAX: 300,
})
export const GEOLOCATION_VALIDATION_VALUE = Object.freeze({
  LATITUDE_MIN: -90,
  LATITUDE_MAX: 90,
  LONGITUDE_MIN: -180,
  LONGITUDE_MAX: 180,
  RADIUS_MIN: 0.1,
})
